import { render } from "./inquiryWrite.vue?vue&type=template&id=20f4e438&ts=true"
import script from "./inquiryWrite.vue?vue&type=script&lang=ts&config=true"
export * from "./inquiryWrite.vue?vue&type=script&lang=ts&config=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__